import { render, staticRenderFns } from "./UploadBoardImage.vue?vue&type=template&id=2693eb16&scoped=true&"
import script from "./UploadBoardImage.vue?vue&type=script&lang=js&"
export * from "./UploadBoardImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadBoardImage.vue?vue&type=style&index=0&id=2693eb16&scoped=true&lang=css&"
import style1 from "./UploadBoardImage.vue?vue&type=style&index=1&id=2693eb16&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693eb16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VChip,VCol,VDialog,VIcon,VSpacer})
